// Italian translations
const it = {
    "nav.home": "HOME",
    "nav.settings": "IMPOSTAZIONI",
    "nav.exit": "ESCI",
    "nav.inventory": "INVENTARIO",
    "nav.loadout": "EQUIPAGGIAMENTO",
    "nav.play": "GIOCA",
    "nav.store": "NEGOZIO",
    "nav.news": "NEWS",
    "nav.friends": "AMICI",
    "nav.recordings": "REGISTRAZIONI",
    "nav.profile": "PROFILO",

    "common.close": "Chiudi",
    "common.back": "Indietro",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.confirm": "Conferma",
    "common.copy": "Copia",
    "common.share": "Condividi",
    "common.locked": "Bloccato",
    "common.unavailable": "Non disponibile in Beta",
    "common.beta": "BETA",
    "common.online": "Online",
    "common.offline": "Offline",

    "lobby.status": "PRONTO AL DISPIEGAMENTO",
    "lobby.slot_left": "Slot Squadra",
    "lobby.slot_right": "Slot Squadra",
    "lobby.slot_disabled": "Gli inviti al party non sono disponibili nella versione Beta.",
    "lobby.mini_status": "IN ATTESA",

    "play.title": "DISPIEGAMENTO",
    "play.subtitle": "SELEZIONA MISSIONE",
    "play.mode_training": "ADDESTRAMENTO",
    "play.mode_training_sub": "VS IA · OFFLINE",
    "play.mode_ranked": "MULTIGIOCATORE CLASSIFICATO",
    "play.mode_ranked_sub": "COMPETITIVO · ONLINE",
    "play.available": "DISPONIBILE",
    "play.beta_lock": "BLOCCO BETA",
    "play.section_map": "MAPPA",
    "play.section_team": "DIMENSIONE SQUADRA",
    "play.section_difficulty": "DIFFICOLTÀ BOT",
    "play.deploy": "DISPIEGA",
    "play.last_loadout": "ULTIMO EQUIPAGGIAMENTO",

    "store.title": "NEGOZIO",
    "store.subtitle": "SKIN · CAPSULE · PACCHETTI",
    "store.locked_title": "Negozio Bloccato",
    "store.locked_message": "Il negozio non è disponibile nella build Beta attuale.",

    "news.title": "NOTIZIE",
    "news.subtitle": "PATCH NOTE · ANNUNCI",

    "loadout.title": "EQUIPAGGIAMENTO",
    "loadout.subtitle": "PRIMARIA · SECONDARIA · MISCHIA · GRANATE",
    "loadout.slot_primary": "PRIMARIA",
    "loadout.slot_secondary": "SECONDARIA",
    "loadout.slot_melee": "MISCHIA",
    "loadout.slot_grenade": "GRANATA",
    "loadout.slot_pistol_start": "PISTOLA INIZIALE",
    "loadout.save": "Salva Equipaggiamento",
    "loadout.saved": "Equipaggiamento salvato",

    "inventory.title": "INVENTARIO",
    "inventory.subtitle": "BILANCIAMENTO ARMI · SKIN",

    "friends.title": "AMICI",
    "friends.subtitle": "SQUADRA",
    "friends.add": "Aggiungi Amico",
    "friends.my_code": "Il Mio Codice Amico",
    "friends.copy_code": "Copia Codice",
    "friends.reset_code": "Rigenera Codice",
    "friends.incoming": "Richieste Ricevute",
    "friends.sent": "Richieste Inviate",
    "friends.online": "Online",
    "friends.offline": "Offline",
    "friends.blocked": "Bloccati",
    "friends.search": "Cerca",
    "friends.remove": "Rimuovi",
    "friends.block": "Blocca",
    "friends.unavailable": "Gli amici online non sono disponibili durante la Beta.",

    "recordings.title": "REGISTRAZIONI",
    "recordings.subtitle": "CATTURA CLIP MANUALE",
    "recordings.start": "Avvia Nuova Registrazione",
    "recordings.stop": "Ferma Registrazione",
    "recordings.mine": "Le Mie Registrazioni",
    "recordings.play": "Riproduci",
    "recordings.rename": "Rinomina",
    "recordings.delete": "Elimina",
    "recordings.download": "Scarica",
    "recordings.experimental":
        "La registrazione è sperimentale nella Beta — vengono usate API di cattura del browser e la qualità può variare.",
    "recordings.indicator": "REC",

    "exit.title": "Esci da CROSSFIRE",
    "exit.message": "Sei sicuro di voler uscire da CROSSFIRE?",
    "exit.confirm": "ESCI DAL GIOCO",

    "profile.title": "PROFILO",
    "profile.subtitle": "OPERATORE",
    "profile.level": "LIVELLO",
    "profile.xp": "XP",
    "profile.matches": "PARTITE",
    "profile.wins": "VITTORIE",
    "profile.losses": "SCONFITTE",
    "profile.kills": "UCCISIONI",
    "profile.deaths": "MORTI",
    "profile.kd": "K/D",
    "profile.rank": "GRADO",
    "profile.rank_beta": "BETA SENZA GRADO",
    "profile.player_id": "ID GIOCATORE",
    "profile.account": "ACCOUNT",
    "profile.account_beta": "OSPITE BETA",

    "settings.title": "IMPOSTAZIONI",
    "settings.tab.graphics": "Grafica",
    "settings.tab.audio": "Audio",
    "settings.tab.controls": "Controlli",
    "settings.tab.gameplay": "Gameplay",
    "settings.tab.language": "Lingua",
};

export default it;
